import { Icon } from "../Icon";
import { IIcon } from "../interfaces/IIcon";

export const overflowMenuIcon: IIcon = new Icon(
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 64"><path fill-rule="evenodd" d="M7.5 48.941c4.142 0 7.5 3.371 7.5 7.53C15 60.629 11.642 64 7.5 64 3.358 64 0 60.629 0 56.47c0-4.158 3.358-7.529 7.5-7.529zm0-24.47c4.142 0 7.5 3.37 7.5 7.529 0 4.158-3.358 7.53-7.5 7.53C3.358 39.53 0 36.157 0 32s3.358-7.53 7.5-7.53zM7.5 0C11.642 0 15 3.371 15 7.53c0 4.158-3.358 7.529-7.5 7.529-4.142 0-7.5-3.371-7.5-7.53C0 3.371 3.358 0 7.5 0z"/></svg>`
);
